<template>
  <div v-if="motivationText.length" class="candidate-motivation">
    <div class="candidate-motivation-title">
      {{ t("ETAB.PAGES.EXTRA.@MOTIVATION_TITLE_GENERIC") }}
    </div>
    <div v-if="extra.cdi_bio" class="candidate-motivation-card">
      <div class="candidate-motivation-card-content">
        {{ motivationText }}
      </div>
      <div v-if="extra.cdi_bio.length > textOverflowLimit" class="candidate-motivation-card-footer">
        <QBtn flat no-caps class="text-underline" :label="t('ETAB.BUTTONS.@SEE_MORE')" @click="showMore" />
      </div>
    </div>
    <MotivationModal v-model:opened="motivationModalOpened" :motivation-text="extra.cdi_bio" />
  </div>
</template>

<script setup>
  import { ref, defineProps, computed } from "vue";
  import { useI18n } from "vue-i18n";
  import MotivationModal from "../Motivation.modal.vue";
  import { limitText } from "@extracadabra/core-v2";

  const TEXT_OVERFLOW_LIMIT = 100;

  const { t } = useI18n();

  const props = defineProps({
    extra: {
      type: Object,
      default: () => ({}),
    },
  });

  const textOverflowLimit = ref(TEXT_OVERFLOW_LIMIT);
  const motivationModalOpened = ref(false);

  const motivationText = computed(() => limitText({ str: props.extra.cdi_bio, limit: textOverflowLimit.value }));

  const showMore = () => {
    motivationModalOpened.value = true;
  };
</script>

<style lang="scss">
  .candidate-motivation {
    margin-top: 20px;
    &-title {
      color: $primary;
      font-size: 22px;
      font-weight: 600;
      margin-left: 5px;
      margin-bottom: 5px;
    }
    &-card {
      padding: 10px;
      background-color: #fff;
      border-radius: 12px;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
      margin-bottom: 20px;
      padding-left: 10px;
    }
    &-card-footer {
      text-align: center;
    }
  }
</style>
